import { render, staticRenderFns } from "./deleteIntegralConfig.vue?vue&type=template&id=386edb12&scoped=true"
import script from "./deleteIntegralConfig.vue?vue&type=script&lang=js"
export * from "./deleteIntegralConfig.vue?vue&type=script&lang=js"
import style0 from "./deleteIntegralConfig.vue?vue&type=style&index=0&id=386edb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386edb12",
  null
  
)

export default component.exports